import { LoginResponse } from "../../models/LoginResponse";
import { slavtAuthHTTP } from "../http";

export function login(credentials: { email: string; password: string }) {
  return slavtAuthHTTP
    .post<LoginResponse>(`/auth/sign-in`, credentials)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function singUp(signUpData: {
  name: string;
  surname: string;
  email: string;
  password: string;
  languageIds: string[];
}) {
  return slavtAuthHTTP
    .post<void>(`/auth/sign-up`, signUpData)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function confirmEmail(token: string) {
  return slavtAuthHTTP
    .post<void>("/auth/verify-email", { token })
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}
